import { Card } from "primereact/card";
import { QuestionResponse } from "../models";
import { Checkbox } from "primereact/checkbox";
import { useEffect } from "react";
import { OptionResponse } from "../models";

export default function CheckboxResponseComponent({ response }: { response: QuestionResponse[] }) {

    useEffect(()=>{
        console.log("checkbox",response)
    },[])
    return (
        <Card>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
                {response.map((res, index) => {
                    let options: OptionResponse[] = [];
                    try {
                        if (res.fieldValue) {
                            options = JSON.parse(res.fieldValue);
                        }
                    } catch (e) {
                        options = [];
                    }
                    if (!Array.isArray(options)) {
                        options = [];
                    }
                    if (options.length > 0) {
                        // Sort options by Sequence (null/undefined last)
                        const sortedOptions = [...options].sort((a, b) => {
                            if (a.Sequence == null) return 1;
                            if (b.Sequence == null) return -1;
                            return a.Sequence - b.Sequence;
                        });
                        return sortedOptions.map((opt, optIdx) => (
                            <div key={optIdx} style={{ display: 'flex', alignItems: 'center', padding: '4px 0' }}>
                                <Checkbox
                                    inputId={`cb${index}_${optIdx}`}
                                    checked={opt.Response?.toUpperCase() === "I ATTEST" || opt.Response?.toUpperCase() === "Y"}
                                    name={res.fieldName}
                                    value={opt.Response}
                                />
                                <label htmlFor={`cb${index}_${optIdx}`} style={{ marginLeft: 8 }}>{opt.OptionText || res.fieldName}</label>
                            </div>
                        ));
                    } else {
                        return (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', padding: '4px 0' }}>
                                <Checkbox
                                    inputId={`cb${index}`}
                                    checked={!!res.fieldValue && (res.fieldValue.toUpperCase().includes("Y") || res.fieldValue.toUpperCase().includes("I ATTEST"))}
                                    name={res.fieldName}
                                    value={res.fieldValue || false}
                                />
                                <label htmlFor={`cb${index}`} style={{ marginLeft: 8 }}>
                                    {res.fieldValue?.toUpperCase() !== "Y" ? (res.fieldValue ?? res.fieldName) : res.fieldName}
                                </label>
                            </div>
                        );
                    }
                })}
            </div>
        </Card>
    );

}